import { Link, RouteComponentProps } from '@reach/router';
import { find } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import SubjectGroups from '../../../../components/settings/subject/SubjectGroups';
import SubjectInfo from '../../../../components/settings/subject/SubjectInfo';
import SubjectMemberList from '../../../../components/settings/subject/SubjectMemberList';
import SubjectTrackers from '../../../../components/settings/subject/SubjectTrackers';
import { ButtonFilled } from '../../../../components/ui';
import { AccountContext } from '../../../../context/account';
import { UserContext } from '../../../../context/UserContext';
import client from '../../../../lib/client';
import { subjectMembersQuery } from '../../../../queries/subjects';
import {
  SubjectMembersQuery,
  SubjectMembersQueryVariables
} from '../../../../queries/__generated__/SubjectMembersQuery';

interface SubjectProps extends RouteComponentProps {
  subject: any;
}

const SubjectSettings: React.FC<SubjectProps> = ({ subject }) => {
  const accountContext = useContext(AccountContext);
  const { user } = useContext(UserContext);
  const [userCanAdmin, setUserCanAdmin] = useState(false);

  useEffect(() => {
    async function canAdminGroup() {
      const result = await client.query<SubjectMembersQuery, SubjectMembersQueryVariables>({
        query: subjectMembersQuery,
        variables: {
          input: {
            subjectId: subject.id
          }
        }
      });

      const match = find(
        result.data.subjectMembers,
        gm => gm.member.id === user.memberIdForAccount(accountContext.selectedAccountId)
      );

      if (match && match!.roleType.toUpperCase() === 'ADMIN') {
        setUserCanAdmin(true);
      }
    }

    canAdminGroup();
  });

  return (
    <>
      <SubjectInfo subject={subject} userCanAdmin={userCanAdmin} />
      <SubjectMemberList subject={subject} userCanAdmin={userCanAdmin} />
      <SubjectGroups subject={subject} />
      <SubjectTrackers subject={subject} userCanAdmin={userCanAdmin} />
      {userCanAdmin && (
        <ButtonFilled
          as={Link}
          to={`/notebook/subject/${subject.id}/delete`}
          data-testid="delete-button"
        >
          Delete Subject
        </ButtonFilled>
      )}
    </>
  );
};

export default SubjectSettings;
